import {
  faCircle,
  faEnvelopeOpenText,
  faMapMarkerAlt,
  faPhoneAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Container, Nav, Navbar, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";

export const Footer = () => {
  const location = useLocation();

  const usePathname = () => {
    return location.pathname;
  };

  return (
    <Container fluid className="footer">
      <Container>
        <Row>
          <hr className="footer-divider-top" />
          <Col sm="12" md="12" lg="4">
            <Navbar.Brand className="footer-logo" href="/">
              Your Logo Here
            </Navbar.Brand>
            <p className="footer-logo-text">
              Short piece of text to explain who you are, what you do, when you
              started trading and what services you offer.
            </p>
          </Col>
          <Col sm="12" md="12" lg="4">
            <h3>Contact</h3>
            <p>
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                size="1x"
                color="#ffcb44"
              />
              &nbsp;&nbsp;&nbsp;Address Name, City, Postcode
            </p>
            <p>
              <FontAwesomeIcon icon={faPhoneAlt} size="1x" color="#ffcb44" />
              &nbsp;&nbsp;&nbsp;07911011993
            </p>
            <p>
              <FontAwesomeIcon
                icon={faEnvelopeOpenText}
                size="1x"
                color="#ffcb44"
              />
              &nbsp;&nbsp;&nbsp;youremail@mail.com
            </p>
          </Col>
          <Col sm="12" md="12" lg="2">
            <h3 className="fm-title">Footer Menu</h3>
            <Nav
              defaultActiveKey={usePathname}
              className="margin-left-right-auto"
            >
              <Nav.Link href="/">
                <FontAwesomeIcon icon={faCircle} size="sm" />
                &nbsp;&nbsp;&nbsp;Home
              </Nav.Link>
              <Nav.Link href="/services">
                <FontAwesomeIcon icon={faCircle} size="sm" />
                &nbsp;&nbsp;&nbsp;Services
              </Nav.Link>
              <Nav.Link href="/gallery">
                <FontAwesomeIcon icon={faCircle} size="sm" />
                &nbsp;&nbsp;&nbsp;Gallery
              </Nav.Link>
              <Nav.Link href="/prices">
                <FontAwesomeIcon icon={faCircle} size="sm" />
                &nbsp;&nbsp;&nbsp;Prices
              </Nav.Link>
              <Nav.Link href="/about">
                <FontAwesomeIcon icon={faCircle} size="sm" />
                &nbsp;&nbsp;&nbsp;About
              </Nav.Link>
              <Nav.Link className="contact-button-alt" href="/contact">
                <FontAwesomeIcon icon={faCircle} size="sm" />
                &nbsp;&nbsp;&nbsp;Contact
              </Nav.Link>
            </Nav>
          </Col>
          <Col sm="12" md="12" lg="2">
            <h3 className="fm-title">Social Links</h3>
            <Nav
              defaultActiveKey={usePathname}
              className="margin-left-right-auto"
            >
              <Nav.Link
                rel="noreferrer"
                href="https://www.facebook.com/"
                target="_blank"
              >
                <FontAwesomeIcon icon={faCircle} size="sm" />
                &nbsp;&nbsp;&nbsp;Facebook
              </Nav.Link>
              <Nav.Link
                rel="noreferrer"
                href="https://www.instagram.com/"
                target="_blank"
              >
                <FontAwesomeIcon icon={faCircle} size="sm" />
                &nbsp;&nbsp;&nbsp;Instagram
              </Nav.Link>
              <Nav.Link
                rel="noreferrer"
                href="https://www.twitter.com/"
                target="_blank"
              >
                <FontAwesomeIcon icon={faCircle} size="sm" />
                &nbsp;&nbsp;&nbsp;Twitter
              </Nav.Link>
              <Nav.Link
                rel="noreferrer"
                href="https://www.linkedin.com/"
                target="_blank"
              >
                <FontAwesomeIcon icon={faCircle} size="sm" />
                &nbsp;&nbsp;&nbsp;LinkedIn
              </Nav.Link>
              <Nav.Link
                rel="noreferrer"
                href="https://www.youtube.com/"
                target="_blank"
              >
                <FontAwesomeIcon icon={faCircle} size="sm" />
                &nbsp;&nbsp;&nbsp;YouTube
              </Nav.Link>
            </Nav>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col sm="12" md="6" lg="10">
            <h4>
              <span>©Your Site Name</span> All Right Reserved.
            </h4>
          </Col>
          <Col sm="12" md="6" lg="2">
            <Nav
              defaultActiveKey={usePathname}
              className="margin-left-right-auto cookies-and-privacy-links"
            >
              <Nav.Link href="/cookies">Cookies</Nav.Link>
              <Nav.Link href="/privacy-policy">Privacy Policy</Nav.Link>
            </Nav>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
